import { isValidNumber } from 'src/consumer/helpers/utilFunctions'
import { formatDuration } from 'src/mentor/helpers/utilityFunctions'
import { calculateNextVisitDate } from '../../PrescriptionMakingPageComponents'
import { PrintableNextVisitColumnLeftSide } from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/body/styledComponents'
export function DefaultNextVisitRowComponent({
  nextVisitInputValue,
  nextVisitInputType,
  prescriptionData,
  showPrescriptionQRCode = false,
  children,
  styleOverrides,
  hideQRCode = false,
}) {
  const nextVisitDateString = calculateNextVisitDate(
    nextVisitInputValue,
    nextVisitInputType,
    'DD/MM/YYYY, dddd',
  )

  const showNextVisitDateInNumber = isValidNumber(nextVisitInputValue) && !!nextVisitInputType

  const nextVisitText = formatDuration(nextVisitInputValue, nextVisitInputType)

  return (
    <>
      <PrintableNextVisitColumnLeftSide>
        {nextVisitInputValue && nextVisitInputType && (
          <>
            <span
              style={{
                fontSize: styleOverrides?.headingFontSize
                  ? `${styleOverrides?.headingFontSize}px`
                  : 'inherit',
                color: styleOverrides?.headingColor || 'inherit',
              }}
            >
              <strong>Next Visit Date</strong>
            </span>
            <div
              style={{
                fontSize: styleOverrides?.fontSizePixels
                  ? `${styleOverrides?.fontSizePixels}px`
                  : 'inherit',
                color: styleOverrides?.color || 'inherit',
              }}
            >
              {nextVisitDateString}{' '}
              {/* {showNextVisitDateInNumber ? `(${nextVisitInputValue} ${nextVisitInputType})` : ''} */}
              {showNextVisitDateInNumber && !!nextVisitText ? `(after ${nextVisitText})` : ''}
            </div>
          </>
        )}
      </PrintableNextVisitColumnLeftSide>
      {children}
      {/* Signature is rendered as a separate EMR section (orderId: signature) when enabled in EMR settings */}
    </>
  )
}

// {!hideQr && (
//   <div className="d-flex align-items-start justify-content-end">
//     {prescriptionData?.prescriptionData?.qrCodeImageId && (
//       <QRCodeImage imageId={prescriptionData?.prescriptionData?.qrCodeImageId} />
//     )}

//     {/* {prescriptionData?.prescriptionData?.qrCodeImageId && (
//           <div className="d-flex flex-column align-items-center">
//             <img
//               src={getImageLink(prescriptionData?.prescriptionData?.qrCodeImageId)}
//               alt="prescription-qr"
//               height="60px"
//               width="60px"
//             ></img>
//             <span style={{ textAlign: 'center' }}>View Online</span>
//           </div>
//         )} */}
//   </div>
// )}
